exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3JFTqqHf7F6gf7isAfdU4O{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-sizing:border-box;box-sizing:border-box}._2hB_6pLTU7tG6jIpgt_Clm{font-size:14px;height:20px;line-height:18px;-ms-flex-item-align:center;align-self:center}html[dir=ltr] ._2hB_6pLTU7tG6jIpgt_Clm{padding:0 5px 0 0}html[dir=rtl] ._2hB_6pLTU7tG6jIpgt_Clm{padding:0 0 0 5px}", ""]);
// Exports
exports.locals = {
	"titleLabelAndDropdown": "_3JFTqqHf7F6gf7isAfdU4O",
	"recurrenceText": "_2hB_6pLTU7tG6jIpgt_Clm"
};